import MotorParseable from "./class.MotorParseable";

export default class VennDiagram extends MotorParseable {
	isClearButtonEnabled() {
		return this.clearButtonIsEnabled;
	}

	constructor(options) {
		super(options);

		this.clearButtonIsEnabled = false;
		this.initialSelectedRegions = this.tryJSONParse(this.model.selectedRegions);
		this.selectionLimit =
			this.model.selectionLimit < 0 ? Infinity : this.model.selectionLimit;
	}

	getNewDriver() {
		return new Motors.Drivers.VennDiagramDriver();
	}

	getStartSignal() {
		let selectedRegions = this.driverOutputs.selectedRegions
			? this.driverOutputs.selectedRegions.slice()
			: this.initialSelectedRegions.slice();

		return {
			isThreeWay: this.model.isThreeWay,
			mode: this.model.mode,
			selectionLimit: this.selectionLimit,
			allowedCharacters: this.model.allowedCharacters.split(""),
			includeUniversalRegion: this.model.includeUniversalRegion,
			labels: this.tryJSONParse(this.model.labels),
			regionText: this.tryJSONParse(this.model.regionText),
			selectedRegions,
			inputValues: Object.assign({}, this.driverOutputs.inputValues),
		};
	}

	shouldInteractionsBeDisabled() {
		return !this.isParsed;
	}

	getCachedResponseSignal(data) {
		return {
			selectedRegions: data.selectedRegions,
			inputValues: data.inputValues,
		};
	}

	onRenderResponse($responseDiv) {
		let preview = this.driverOutputs[this.previewKey] || [];

		return new Promise((resolve) => {
			this.clearButtonIsEnabled = !this.isResponseInitial();
			this.rerenderClearButton();

			if (this.previewKey !== "noPreview") {
				if (this.previewKey === "selectedRegions") {
					if (preview.length === 0) {
						$responseDiv.html("<em>No regions selected.</em>");
					} else {
						$responseDiv.text("[" + preview.join(", ") + "]");
					}
				} else {
					if (
						preview.length === 0 ||
						preview.every((v) => v.split(": ")[1].length === 0)
					) {
						$responseDiv.html("<em>No blanks filled.</em>");
					} else {
						$responseDiv.text("[" + preview.join(", ") + "]");
					}
				}
			}

			this.setSubmittable(this.isResponseSubmittable());
			resolve();
		});
	}

	isResponseSubmittable() {
		switch (this.model.mode) {
			case "select":
				return (
					this.driverOutputs.selectedRegions &&
					this.driverOutputs.selectedRegions.length > 0
				);
			case "input":
				return (
					this.driverOutputs.inputValues &&
					Object.values(this.driverOutputs.inputValues).every(
						(value) => value !== ""
					)
				);
		}
	}

	isResponseInitial() {
		let response;
		switch (this.model.mode) {
			case "select":
				response = this.driverOutputs.selectedRegions;
				if (response) {
					if (response.length === this.initialSelectedRegions.length) {
						return response.every(
							(v) => this.initialSelectedRegions.indexOf(v) > -1
						);
					} else {
						return false;
					}
				} else {
					return this.initialSelectedRegions.length === 0;
				}
			case "input":
				// No seeded inputs allowed, so just check if empty.
				response = this.driverOutputs.inputValues || {};
				return (
					Object.values(response).length === 0 ||
					Object.values(response).every((v) => v.length === 0)
				);
		}
	}
}
